import { render, staticRenderFns } from "./UploadDocumentDialog.vue?vue&type=template&id=33d12b76&scoped=true"
import script from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
export * from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentDialog.vue?vue&type=style&index=0&id=33d12b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d12b76",
  null
  
)

export default component.exports